module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_9006.a687dc32.png";